// theme.js — Cart-Drawer + Sticky Add-to-Cart + Qty-Stepper
(function () {
  const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' ' + (window.theme?.currency || '€');

  // ── Cart-Drawer ────────────────────────────────────────────────────
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const itemsEl = drawer.querySelector('[data-cart-items]');
  const footEl = drawer.querySelector('[data-cart-foot]');
  const totalEl = drawer.querySelector('[data-cart-total]');
  const progressEl = drawer.querySelector('[data-shipping-progress]');
  const cartCountEls = document.querySelectorAll('.site-header__cart-count, [data-cart-count]');

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  drawer.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', close));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  // Cart-Icon im Header öffnet Drawer statt zur Cart-Seite zu navigieren
  document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach(a => {
    // Nur das Header-Icon, nicht andere Cart-Links (z. B. im Drawer selbst)
    if (a.closest('.cart-drawer') || a.closest('.site-footer')) return;
    a.addEventListener('click', e => {
      e.preventDefault();
      fetchAndRender(true);
    });
  });

  async function fetchAndRender(openAfter) {
    const res = await fetch(window.theme.routes.cart, { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();
    render(cart);
    if (openAfter) open();
  }

  function render(cart) {
    cartCountEls.forEach(el => el.textContent = cart.item_count);

    if (!cart.item_count) {
      itemsEl.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Ihr Warenkorb ist leer.</p>
          <a href="/collections/all" class="btn btn--ghost" data-cart-close>Zur Boutique</a>
        </div>`;
      itemsEl.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', close));
      footEl.hidden = true;
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <article class="cart-line" data-key="${item.key}">
        <a href="${item.url}" class="cart-line__media">
          ${item.featured_image?.url
            ? `<img src="${item.featured_image.url.replace(/\.(jpg|jpeg|png|webp)/i, '_180x.$1')}" alt="${escape(item.product_title)}">`
            : `<div class="cart-line__media-fallback">${escape(item.product_title.slice(0, 2))}</div>`}
        </a>
        <div class="cart-line__info">
          <a href="${item.url}" class="cart-line__title">${escape(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-line__variant">${escape(item.variant_title)}</p>` : ''}
          <div class="cart-line__row">
            <div class="qty qty--mini">
              <button type="button" data-qty-dec aria-label="Weniger">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-inc aria-label="Mehr">+</button>
            </div>
            <strong class="cart-line__price">${fmt(item.final_line_price)}</strong>
          </div>
          <button type="button" class="cart-line__remove" data-remove aria-label="Entfernen">Entfernen</button>
        </div>
      </article>
    `).join('');

    totalEl.textContent = fmt(cart.total_price);

    // Versandkostenfrei-Progress
    if (progressEl) {
      const freeFrom = (window.theme?.freeFrom || 89) * 100;
      const remaining = freeFrom - cart.total_price;
      if (remaining <= 0) {
        progressEl.innerHTML = `<span class="cart-drawer__free">✓ Versandkostenfrei!</span>`;
      } else {
        const pct = Math.max(0, Math.min(100, (cart.total_price / freeFrom) * 100));
        progressEl.innerHTML = `
          <p>Noch <strong>${fmt(remaining)}</strong> bis zum versandkostenfreien Versand</p>
          <div class="cart-drawer__progress"><span style="width:${pct}%"></span></div>`;
      }
    }

    footEl.hidden = false;

    // Wire up qty + remove
    itemsEl.querySelectorAll('.cart-line').forEach(line => {
      const key = line.dataset.key;
      const item = cart.items.find(i => i.key === key);
      line.querySelector('[data-qty-dec]').addEventListener('click', () => change(key, item.quantity - 1));
      line.querySelector('[data-qty-inc]').addEventListener('click', () => change(key, item.quantity + 1));
      line.querySelector('[data-remove]').addEventListener('click', () => change(key, 0));
    });
  }

  async function change(key, qty) {
    const res = await fetch(window.theme.routes.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    const cart = await res.json();
    render(cart);
  }

  // ── Add-to-cart forms abfangen ────────────────────────────────────
  document.body.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    // Quick-Add-Button-State setzen
    const btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    const data = new FormData(form);
    const res = await fetch(window.theme.routes.add, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data,
    });

    if (btn) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      setTimeout(() => { btn.classList.remove('is-success'); btn.disabled = false; }, 700);
    }

    if (res.ok) {
      fetchAndRender(true);
    } else {
      const err = await res.json().catch(() => ({}));
      alert(err.description || 'Konnte nicht in den Warenkorb gelegt werden.');
    }
  });

  // ── Initial render (z. B. wenn man die Seite mit gefülltem Cart lädt) ─
  fetchAndRender(false);

  // ── PDP-Description in saubere Blöcke gliedern ───────────────────
  // Arbeitet direkt auf dem HTML-String (zuverlässiger als DOM-Klassifizierung).
  document.querySelectorAll('[data-pdp-desc]').forEach(desc => {
    if (desc.dataset.parsed === 'true') return;
    desc.dataset.parsed = 'true';

    let html = desc.innerHTML;

    // 1) "Bon appétit!" entfernen
    html = html.replace(/<p[^>]*>\s*Bon\s?app[ée]tit\s*!?\s*<\/p>/gi, '');

    // 2) Helper: HTML-Block zwischen Marker und Stop-Markern extrahieren.
    //    Sucht ab `from` (Marker-Anfang) bis zum nächsten Stop-Marker oder Doc-Ende.
    function extractSection(html, startRegex, stopRegex) {
      const start = html.search(startRegex);
      if (start < 0) return null;
      const rest = html.slice(start);
      const stopMatch = stopRegex ? rest.slice(1).search(stopRegex) : -1;
      const end = stopMatch >= 0 ? start + 1 + stopMatch : html.length;
      return { start, end, content: html.slice(start, end) };
    }

    // 3) Section-Marker definieren
    const ingredientsRe = /<p[^>]*>\s*(?:<strong>\s*)?Zutaten[:\s]/i;
    const allergensRe   = /<p[^>]*>\s*(?:<strong>\s*)?Achtung/i;
    const nutritionRe   = /<p[^>]*>\s*N[äa]hrwert/i;
    const storageRe     = /<p[^>]*>\s*(K[üu]hl|Lagerung|Haltbarkeit)/i;
    const stopForIngred = new RegExp('(' + nutritionRe.source + '|' + storageRe.source + ')', 'i');
    const stopForNutri  = new RegExp(storageRe.source, 'i');
    const stopForStorage = null;

    // 4) Sektionen extrahieren — frühest zuerst
    const sections = []; // { type, content, start, end }
    const ing = extractSection(html, ingredientsRe, stopForIngred);
    if (ing) sections.push({ ...ing, type: 'ingredients' });

    const nutri = extractSection(html, nutritionRe, stopForNutri);
    if (nutri) sections.push({ ...nutri, type: 'nutrition' });

    const storage = extractSection(html, storageRe, stopForStorage);
    if (storage) sections.push({ ...storage, type: 'storage' });

    if (!sections.length) return;

    // 5) Stelle sicher, dass Sektionen nicht überlappen — sortiere nach Start
    sections.sort((a, b) => a.start - b.start);
    // Korrigiere Endpunkte: ende = Anfang der nächsten Sektion (falls überlappend)
    for (let i = 0; i < sections.length - 1; i++) {
      if (sections[i].end > sections[i + 1].start) {
        sections[i].end = sections[i + 1].start;
        sections[i].content = html.slice(sections[i].start, sections[i].end);
      }
    }

    // 6) Baue neuen HTML auf: Intro vor erster Section + Sections als Info-Blöcke
    let out = html.slice(0, sections[0].start);
    const labels = {
      ingredients: 'Zutaten & Allergene',
      nutrition:   'Nährwerte',
      storage:     'Lagerung & Haltbarkeit',
    };

    sections.forEach(sec => {
      let content = sec.content;
      // Bei ingredients: auch Achtung/Allergene mit reinholen, falls direkt danach
      out += `<div class="pdp__info-block pdp__info-block--${sec.type}">`
          +  `<h3>${labels[sec.type]}</h3>${content}</div>`;
    });

    // 7) Eventueller Tail nach letzter Section (sollte leer sein)
    out += html.slice(sections[sections.length - 1].end);

    desc.innerHTML = out;
  });

  // ── Nährwert-Block hübsch parsen ──────────────────────────────────
  document.querySelectorAll('.pdp__info-block--nutrition').forEach(block => {
    const paras = Array.from(block.querySelectorAll('p, div'));
    if (!paras.length) return;

    // Sammele Zeilen, splitte ggf. nach <br> oder Doppelpunkten/Zeilenumbrüchen
    const lines = [];
    paras.forEach(p => {
      const text = p.innerHTML
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .trim();
      text.split(/\n+/).forEach(l => {
        const trimmed = l.trim();
        if (trimmed && !/^(Nährwerte|Pro 100\s?g)/i.test(trimmed)) lines.push(trimmed);
      });
    });

    if (!lines.length) return;

    // Identifiziere Energie-Zeile (enthält kJ oder kcal)
    let energy = null;
    const others = [];
    lines.forEach(l => {
      if (/kJ|kcal|Kilokalorien|Kilojoule/i.test(l) && !energy) {
        energy = l;
      } else {
        others.push(l);
      }
    });

    function splitRow(line) {
      // "Fett 44 g" oder "Energie: 433 kcal" oder "Davon gesättigte Fettsäuren 20 g"
      const m = line.match(/^([^:]+?)[\s:]+([\d.,]+\s*\S+(?:\s*\(?[\d.,\s\S]+?\)?)?)\s*$/);
      if (m) return { label: m[1].trim().replace(/[:,]\s*$/, ''), value: m[2].trim() };
      return { label: line, value: '' };
    }

    let html = '<div class="nutri">';
    if (energy) {
      const { label, value } = splitRow(energy);
      // Parse value für "1814 kJ und 433 kcal"
      const kj = value.match(/([\d.,]+)\s*(?:kJ|Kilojoule)/i);
      const kcal = value.match(/([\d.,]+)\s*(?:kcal|Kilokalorien)/i);
      html += `<div class="nutri__energy">
        <p class="nutri__energy-label">Energiegehalt pro 100 g</p>
        <div class="nutri__energy-values">
          ${kcal ? `<div><strong>${kcal[1]}</strong> <span>kcal</span></div>` : ''}
          ${kj ? `<div><strong>${kj[1]}</strong> <span>kJ</span></div>` : ''}
        </div>
      </div>`;
    }

    if (others.length) {
      html += '<dl class="nutri__rows">';
      others.forEach(line => {
        const { label, value } = splitRow(line);
        const isSub = /^Davon\b/i.test(label);
        html += `<div class="nutri__row${isSub ? ' nutri__row--sub' : ''}">
          <dt>${escape(label)}</dt>
          <dd>${escape(value)}</dd>
        </div>`;
      });
      html += '</dl>';
    }
    html += '</div>';

    // Original-<p>s entfernen, neuen Inhalt einfügen (Heading bleibt)
    const heading = block.querySelector('h3');
    block.innerHTML = '';
    if (heading) block.appendChild(heading);
    block.insertAdjacentHTML('beforeend', html);
  });

  // ── Quick-View-Modal ──────────────────────────────────────────────
  const qv = document.getElementById('QuickView');
  if (qv) {
    const qvLoading = qv.querySelector('[data-qv-loading]');
    const qvContent = qv.querySelector('[data-qv-content]');
    const qvMedia = qv.querySelector('[data-qv-media]');
    const qvVendor = qv.querySelector('[data-qv-vendor]');
    const qvTitle = qv.querySelector('[data-qv-title]');
    const qvDesc = qv.querySelector('[data-qv-desc]');
    const qvPrice = qv.querySelector('[data-qv-price]');
    const qvForm = qv.querySelector('[data-qv-form]');
    const qvVariantId = qv.querySelector('[data-qv-variant-id]');
    const qvVariants = qv.querySelector('[data-qv-variants]');
    const qvChips = qv.querySelector('[data-qv-chips]');
    const qvQty = qv.querySelector('[data-qv-qty]');
    const qvLink = qv.querySelector('[data-qv-link]');
    let qvProduct = null;
    let qvSelectedVariant = null;

    function qvOpen() {
      qv.classList.add('is-open');
      qv.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function qvClose() {
      qv.classList.remove('is-open');
      qv.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    qv.querySelectorAll('[data-qv-close]').forEach(b => b.addEventListener('click', qvClose));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && qv.classList.contains('is-open')) qvClose(); });

    // Bag-Button auf Karten mit data-quick-view → öffnet Modal
    document.body.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.dataset.quickView;
      qvLoading.hidden = false;
      qvContent.hidden = true;
      qvOpen();
      try {
        const res = await fetch('/products/' + handle + '.js');
        qvProduct = await res.json();
        renderQuickView(qvProduct);
      } catch (err) {
        qvClose();
      }
    });

    function renderQuickView(p) {
      qvVendor.textContent = p.vendor || '';
      qvTitle.textContent = p.title;
      qvDesc.textContent = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
      qvLink.href = '/products/' + p.handle;
      qvQty.value = 1;

      // Media
      const img = p.featured_image || p.images?.[0];
      qvMedia.innerHTML = img ? `<img src="${img}" alt="${escape(p.title)}">` : '';

      // Varianten als Chips
      if (p.variants.length > 1) {
        qvChips.innerHTML = p.variants.map(v => `
          <button type="button" class="qv-chip ${!v.available ? 'qv-chip--soldout' : ''}"
                  data-variant-id="${v.id}" ${!v.available ? 'disabled' : ''}>
            ${escape(v.title)}
          </button>
        `).join('');
        qvVariants.hidden = false;
        const first = p.variants.find(v => v.available) || p.variants[0];
        selectVariant(first);

        qvChips.querySelectorAll('[data-variant-id]').forEach(chip => {
          chip.addEventListener('click', () => {
            const id = chip.dataset.variantId;
            const v = p.variants.find(x => String(x.id) === id);
            selectVariant(v);
          });
        });
      } else {
        qvVariants.hidden = true;
        selectVariant(p.variants[0]);
      }

      qvLoading.hidden = true;
      qvContent.hidden = false;
    }

    function selectVariant(v) {
      qvSelectedVariant = v;
      qvVariantId.value = v.id;
      qvPrice.textContent = fmt(v.price);
      qvChips.querySelectorAll('[data-variant-id]').forEach(c => {
        c.classList.toggle('is-active', String(c.dataset.variantId) === String(v.id));
      });
      const btn = qv.querySelector('[data-qv-add]');
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
    }

    // Qty-Stepper im Modal
    qv.querySelector('[data-qv-qty-minus]').addEventListener('click', () => {
      qvQty.value = Math.max(1, parseInt(qvQty.value || '1', 10) - 1);
    });
    qv.querySelector('[data-qv-qty-plus]').addEventListener('click', () => {
      qvQty.value = parseInt(qvQty.value || '1', 10) + 1;
    });

    // Form-Submit: Modal schließen, Cart-Drawer öffnen
    qvForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = qv.querySelector('[data-qv-add]');
      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt …';
      const data = new FormData(qvForm);
      const res = await fetch(window.theme.routes.add, {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: data,
      });
      btn.disabled = false;
      btn.textContent = 'In den Warenkorb';
      if (res.ok) {
        qvClose();
        fetchAndRender(true);
      } else {
        const err = await res.json().catch(() => ({}));
        alert(err.description || 'Konnte nicht in den Warenkorb gelegt werden.');
      }
    });
  }

  // ── Qty-Stepper auf PDP (für die normale, sichtbare Menge-Auswahl) ────
  document.querySelectorAll('.qty:not(.qty--mini)').forEach(q => {
    const input = q.querySelector('input');
    if (!input) return;
    q.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    q.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // ── Sticky Add-to-Cart auf PDP-Mobile ─────────────────────────────
  const pdpForm = document.querySelector('.pdp__form');
  const pdpBtn = pdpForm?.querySelector('button[type="submit"]');
  if (pdpForm && pdpBtn) {
    const sticky = document.createElement('div');
    sticky.className = 'pdp-sticky';
    sticky.innerHTML = `
      <div class="pdp-sticky__inner">
        <div class="pdp-sticky__info">
          <span class="pdp-sticky__title">${escape(document.querySelector('.pdp__info h1')?.textContent || '')}</span>
          <span class="pdp-sticky__price">${escape(document.querySelector('.pdp__price')?.textContent || '')}</span>
        </div>
        <button type="button" class="btn btn--primary pdp-sticky__btn">In den Warenkorb</button>
      </div>`;
    document.body.appendChild(sticky);
    sticky.querySelector('.pdp-sticky__btn').addEventListener('click', () => {
      pdpForm.requestSubmit ? pdpForm.requestSubmit() : pdpForm.submit();
    });

    // Sichtbar nur wenn das Original-Form außerhalb des Viewports ist (auf Mobile)
    const observer = new IntersectionObserver(entries => {
      const formVisible = entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', !formVisible);
    }, { threshold: 0 });
    observer.observe(pdpBtn);
  }

  function escape(s) {
    return String(s).replace(/[&<>"']/g, m => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m]));
  }

  // ── Mobile-Nav-Drawer ──────────────────────────────────────────────
  const mobileNav = document.getElementById('MobileNav');
  if (mobileNav) {
    const backdrop = document.querySelector('.site-nav-mobile__backdrop');
    function mnOpen() {
      mobileNav.classList.add('is-open');
      backdrop.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function mnClose() {
      mobileNav.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-mobile-nav-open]').forEach(b => b.addEventListener('click', mnOpen));
    document.querySelectorAll('[data-mobile-nav-close]').forEach(b => b.addEventListener('click', mnClose));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) mnClose();
    });
  }

  // ── Search-Drawer ─────────────────────────────────────────────────
  const searchDrawer = document.getElementById('SearchDrawer');
  if (searchDrawer) {
    const sInput = searchDrawer.querySelector('[data-search-input]');
    const sResults = searchDrawer.querySelector('[data-search-results]');
    let sTimer = null;

    function sOpen() {
      searchDrawer.classList.add('is-open');
      searchDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => sInput.focus(), 80);
    }
    function sClose() {
      searchDrawer.classList.remove('is-open');
      searchDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-search-open]').forEach(b => b.addEventListener('click', sOpen));
    searchDrawer.querySelectorAll('[data-search-close]').forEach(b => b.addEventListener('click', sClose));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && searchDrawer.classList.contains('is-open')) sClose();
    });

    sInput.addEventListener('input', () => {
      const q = sInput.value.trim();
      clearTimeout(sTimer);
      if (q.length < 2) {
        sResults.innerHTML = `
          <div class="search-drawer__hint">
            <p class="eyebrow">Tipp</p>
            <p>Stöbern Sie nach Produkt, Region oder Manufaktur. Tippen Sie z. B. „Salz", „Périgord" oder „Aquasel".</p>
          </div>`;
        return;
      }
      sTimer = setTimeout(() => fetchPredictive(q), 200);
    });

    async function fetchPredictive(q) {
      sResults.innerHTML = `<div class="search-drawer__loading"><div class="quick-view__spinner"></div></div>`;
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q)
                  + '&resources[type]=product,collection,page'
                  + '&resources[limit]=8&resources[options][unavailable_products]=last';
        const res = await fetch(url);
        const data = await res.json();
        renderResults(q, data.resources?.results || {});
      } catch (e) {
        sResults.innerHTML = '<div class="search-drawer__hint"><p>Suche konnte nicht geladen werden.</p></div>';
      }
    }

    function renderResults(q, r) {
      const products = r.products || [];
      const collections = r.collections || [];
      const pages = r.pages || [];

      if (!products.length && !collections.length && !pages.length) {
        sResults.innerHTML = `
          <div class="search-drawer__hint">
            <p class="eyebrow">Keine Treffer</p>
            <p>Für „${escape(q)}" haben wir nichts gefunden. Probieren Sie es mit einem anderen Begriff.</p>
          </div>`;
        return;
      }

      let html = '';
      if (collections.length) {
        html += '<div class="search-drawer__group"><p class="eyebrow">Kategorien</p><div class="search-drawer__cats">'
              + collections.map(c => `<a href="${c.url}" class="search-drawer__cat">${escape(c.title)}</a>`).join('')
              + '</div></div>';
      }
      if (products.length) {
        html += '<div class="search-drawer__group"><p class="eyebrow">Produkte</p><div class="search-drawer__products">';
        products.forEach(p => {
          const img = p.featured_image?.url || p.image;
          html += `<a href="${p.url}" class="search-drawer__product">
            <div class="search-drawer__product-media">${img ? `<img src="${img}" alt="">` : ''}</div>
            <div>
              <div class="search-drawer__product-title">${escape(p.title)}</div>
              <div class="search-drawer__product-price">${fmt(p.price * 100)}</div>
            </div>
          </a>`;
        });
        html += '</div></div>';
      }
      if (pages.length) {
        html += '<div class="search-drawer__group"><p class="eyebrow">Seiten</p><ul class="search-drawer__pages">'
              + pages.map(p => `<li><a href="${p.url}">${escape(p.title)}</a></li>`).join('')
              + '</ul></div>';
      }
      html += `<div class="search-drawer__all"><a href="/search?q=${encodeURIComponent(q)}" class="btn btn--ghost">Alle Treffer für „${escape(q)}"</a></div>`;
      sResults.innerHTML = html;
    }
  }
})();
